export const homeConstants = {
    HOME_GET_REALTIME_REWARD_CODE_REQUEST:
        "HOME_GET_REALTIME_REWARD_CODE_REQUEST",
    HOME_GET_REALTIME_REWARD_CODE_COMPLETE:
        "HOME_GET_REALTIME_REWARD_CODE_COMPLETE",

    HOME_GET_REALTIME_REWARD_REASON_LIST_REQUEST:
        "HOME_GET_REALTIME_REWARD_REASON_LIST_REQUEST",
    HOME_GET_REALTIME_REWARD_REASON_LIST_COMPLETE:
        "HOME_GET_REALTIME_REWARD_REASON_LIST_COMPLETE",

    HOME_GET_PARTICIPANT_LIST_REQUEST: "HOME_GET_PARTICIPANT_LIST_REQUEST",
    HOME_GET_PARTICIPANT_LIST_COMPLETE: "HOME_GET_PARTICIPANT_LIST_COMPLETE",

    HOME_SMS_REALTIME_REWARD_CODE_REQUEST:
        "HOME_SMS_REALTIME_REWARD_CODE_REQUEST",
    HOME_SMS_REALTIME_REWARD_CODE_COMPLETE:
        "HOME_SMS_REALTIME_REWARD_CODE_COMPLETE",

    HOME_CAMPAIGN_LIST_REQUEST: "HOME_CAMPAIGN_LIST_REQUEST",
    HOME_CAMPAIGN_LIST_COMPLETE: "HOME_CAMPAIGN_LIST_COMPLETE",

    HOME_GET_REAL_TIME_REWARD_CAMPAIGN_REQUEST:
        "HOME_GET_REAL_TIME_REWARD_CAMPAIGN_REQUEST",
    HOME_GET_REAL_TIME_REWARD_CAMPAIGN_COMPLETE:
        "HOME_GET_REAL_TIME_REWARD_CAMPAIGN_COMPLETE",

    HOME_CLEAR: "HOME_CLEAR",

    HOME_CHATBOT_REPLY_QUESTION_REQUEST: "HOME_CHATBOT_REPLY_QUESTION_REQUEST",
    HOME_CHATBOT_REPLY_QUESTION_COMPLETE:
        "HOME_CHATBOT_REPLY_QUESTION_COMPLETE",

    HOME_GET_CHATBOT_FAQ_QUESTIONS_REQUEST:
        "HOME_GET_CHATBOT_FAQ_QUESTIONS_REQUEST",
    HOME_GET_CHATBOT_FAQ_QUESTIONS_COMPLETE:
        "HOME_GET_CHATBOT_FAQ_QUESTIONS_COMPLETE",
    GET_PARTICIPANT_JOB_ROLES_REQUEST: "GET_PARTICIPANT_JOB_ROLES_REQUEST",
    GET_PARTICIPANT_JOB_ROLES_COMPLETE: "GET_PARTICIPANT_JOB_ROLES_COMPLETE",

    GET_DEALER_PARTICIPANT_LIST_REQUEST: "GET_DEALER_PARTICIPANT_LIST_REQUEST",
    GET_DEALER_PARTICIPANT_LIST_COMPLETE:
        "GET_DEALER_PARTICIPANT_LIST_COMPLETE",

    REGISTER_DEALER_PARTICIPANT_REQUEST: "REGISTER_DEALER_PARTICIPANT_REQUEST",
    REGISTER_DEALER_PARTICIPANT_COMPLETE:
        "REGISTER_DEALER_PARTICIPANT_COMPLETE",

    REMOVE_DEALER_PARTICIPANT_REQUEST: "REMOVE_DEALER_PARTICIPANT_REQUEST",
    REMOVE_DEALER_PARTICIPANT_COMPLETE: "REMOVE_DEALER_PARTICIPANT_COMPLETE",

    UPDATE_DEALER_PARTICIPANT_STATUS_REQUEST:
        "UPDATE_DEALER_PARTICIPANT_STATUS_REQUEST",
    UPDATE_DEALER_PARTICIPANT_STATUS_COMPLETE:
        "UPDATE_DEALER_PARTICIPANT_STATUS_COMPLETE",

    SEND_ACTIVATE_ACCOUNT_REQUEST: "SEND_ACTIVATE_ACCOUNT_REQUEST",
    SEND_ACTIVATE_ACCOUNT_COMPLETE: "SEND_ACTIVATE_ACCOUNT_COMPLETE",

    HOME_USER_LOGIN_STATUS_REQUEST:'HOME_USER_LOGIN_STATUS_REQUEST',
    HOME_USER_LOGIN_STATUS_COMPLETE:'HOME_USER_LOGIN_STATUS_COMPLETE',

    HOME_GET_TEAM_GAME_PLAY_DETAILS_REQUEST:'HOME_GET_TEAM_GAME_PLAY_DETAILS_REQUEST',
    HOME_GET_TEAM_GAME_PLAY_DETAILS_COMPLETE:'HOME_GET_TEAM_GAME_PLAY_DETAILS_COMPLETE',

    HOME_GET_TEAM_SEND_GAME_PLAY_CODE_REQUEST:'HOME_GET_TEAM_SEND_GAME_PLAY_CODE_REQUEST',
    HOME_GET_TEAM_SEND_GAME_PLAY_CODE_COMPLETE:'HOME_GET_TEAM_SEND_GAME_PLAY_CODE_COMPLETE',

    HOME_GET_TEAM_RESET_GAME_PLAY_CODE_REQUEST:'HOME_GET_TEAM_RESET_GAME_PLAY_CODE_REQUEST',
    HOME_GET_TEAM_RESET_GAME_PLAY_CODE_COMPLETE:'HOME_GET_TEAM_RESET_GAME_PLAY_CODE_COMPLETE',

    HOME_GET_NOTIFICATIONS_REQUEST:"HOME_GET_NOTIFICATIONS_REQUEST",
    HOME_GET_NOTIFICATIONS_COMPLETE:"HOME_GET_NOTIFICATIONS_COMPLETE",

    HOME_DELETE_NOTIFICATIONS_REQUEST:"HOME_DELETE_NOTIFICATIONS_REQUEST",
    HOME_DELETE_NOTIFICATIONS_COMPLETE:"HOME_DELETE_NOTIFICATIONS_COMPLETE",

    HOME_GET_NOTIFICATION_COUNT_REQUEST:"HOME_GET_NOTIFICATION_COUNT_REQUEST",
    HOME_GET_NOTIFICATION_COUNT_COMPLETE:"HOME_GET_NOTIFICATION_COUNT_COMPLETE",
};

